export const CALENDLY_LINK =
  "https://calendly.com/talentpopdemo/talentpop-intro-call-redo";
export const LEARN_MORE_LINK = "https://www.talentpop.co/customer-service";
